import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import './patio.css'

const PatioComponent = (props) => {

    var avulso = [];

    return (
        <section className="qtd-veiculo-patio">
            {props.varPatio?.map((item) => {

                if (avulso.lenght < 0) {
                    avulso = [0]
                }
                return (
                    <article key={item.idpatio} className="progressbar col-12 col-md-12">
                        <Box sx={{ width: '95%', padding: '1rem' }}>

                            <Typography gutterBottom variant="h6" component="div">
                                {item.patio}
                            </Typography>

                            <LinearProgress variant="determinate" color="success" value={Math.round((item.vagas_usada * 100) / item.vagas)} />
                            <br />

                            <Typography variant="body2" color="text.secondary">
                                Total de vagas: {item.vagas} | Disponiveis: {item.vagas - item.vagas_usada}
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                Utilizadas: {parseInt(item.vagas_usada)}
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                Tickets: {parseInt(item.tickets)}
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                Credenciados: {parseInt(item.credenciados)}
                            </Typography>
                        </Box>
                    </article>
                )
            })}
            <br />
        </section>
    );
};
export default PatioComponent;